import { OperationType, VehicleInfo } from "Store/findVehicle/interfaces";
import { createRequest, getError } from "Utils/requestUtils";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  findVehicleStart,
  findVehicleSucceeded,
  operationFailed,
} from "./slice";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* findVehicle({ payload }: ReturnType<typeof findVehicleStart>) {
  try {
    const finalEndpointUrl = `/open/insurance/vehicle/registration/car/${payload.licensePlateNumber}`;
    const { data } = yield call(createRequest, {
      method: "post",
      requestBody: {
        customerRef: payload.customerRef,
      },
      url: finalEndpointUrl,
    });
    yield put(findVehicleSucceeded(data as VehicleInfo));
    payload.onSuccess?.call(undefined, data);
  } catch (e) {
    yield put(
      operationFailed({
        operationType: OperationType.FIND_VEHICLE,
        response: getError(e),
      }),
    );
  }
}

export function* findVehicleSaga(): Generator {
  yield takeLatest(findVehicleStart, findVehicle);
}
